import JsBridge from "./JsBridge";

import router from "../../router/index";
/**
 * 设备检测缓存 - 简单高效的解决方案
 * - 一次性计算，后续直接访问缓存值
 * - 无依赖、零开销、最优性能
 */
const deviceCache = (() => {
  const ua = navigator.userAgent;
  return {
    isApp: /(tcdcApp)/i.test(ua),
    isIos: /(iPhone|iPad|iPod|iOS)/i.test(ua),
    isAndroid: /(Android)/i.test(ua),
    isAideApp: /(aideApp)/i.test(ua),
    h5Debug: /X-Client\/Embed/i.test(ua)
  };
})();

//判断是否是ios
function isIos() {
  return deviceCache.isIos;
}
//判断是否是苹果好用app
function isAideApp() {
  return deviceCache.isAideApp;
}

// 打开计算器页面
function tcOpenCalculatorPage(url, title) {
  if (deviceCache.isAideApp) {
    JsBridge.callHandler("tcOpenCalculatorPage", (res) => { });
  }
}
//判断是否是android
function isAndroid() {
  return deviceCache.isAndroid;
}

function isApp() {
  return deviceCache.isApp;
}
function h5Debug() {
  //检查ua中 "X-Client/Embed" 字段 是否存在 存在则返回true 不存在则返回false
  return deviceCache.h5Debug;
}

//图片上传三次失败的回调
function tcThreeUploadError() {
  return new Promise((resolve, rej) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcThreeUploadError", "", (res) => {
        resolve(res);
      });
    } else {
      reject(new Error("不是APP内的调用"));
    }
  });
}
//Android生命周期onCreate 页面每次创建时调用，只会调用一次
function tcAppOnCrate(callback) {
  JsBridge.registerHandler("tcAppOnCrate", (res) => {
    callback(res);
  });
}
//Android生命周期onResume 页面每次显示都会调用
function tcAppOnResume(callback) {
  if (deviceCache.isApp || deviceCache.isAideApp) {
    JsBridge.registerHandler("tcAppOnResume", (res) => {
      callback(res);
    });
  }
}
//Android生命周期onPause 页面每次显示都会调用
function tcAppOnPause(callback) {
  if (deviceCache.isApp) {
    JsBridge.registerHandler("tcAppOnPause", (res) => {
      callback(res);
    });
  }
}
//获取键盘是否显示的状态
function tcKeyboardStatus(callback) {
  if (deviceCache.isApp) {
    JsBridge.registerHandler("tcKeyboardStatus", (res) => {
      callback(res);
    });
  }
}
//tab切换回调
function tcTabChange(callback) {
  if (deviceCache.isApp) {
    JsBridge.registerHandler("tcTabChange", (res) => {
      callback(res);
    });
  }
}
//Android生命周期onDestroy 销毁资源
function tcAppOnDestroy(callback) {
  if (deviceCache.isApp) {
    JsBridge.registerHandler("tcAppOnDestroy", (res) => {
      callback(res);
    });
  }
}
// 根据url跳转不同activity
function tcJumpActivity(url, env = 0) {
  if (deviceCache.isApp) {
    if (env == 0) {
      url = location.origin + url;
    }
    JsBridge.callHandler("tcJumpActivity", url, (res) => {
      //    callback(res)
    });
  } else {
    // callback(true)
    if (env == 0) {
      router.push(url);
    } else {
      location.href = url;
    }
  }
}

// 苹果甜瓜好用app专用 根据url跳转不同activity
function tcJumpAideAppActivity(url, env = 0) {
  if (deviceCache.isAideApp) {
    if (env == 0) {
      url = location.origin + url;
    }
    JsBridge.callHandler("tcJumpAideAppActivity", url, (res) => { });
  } else {
    if (env == 0) {
      router.push(url);
    } else {
      location.href = url;
    }
  }
}
// 根据三方协议url跳转不同activity title显示标题
function tcOtherProtocolJump(url, title) {
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcOtherProtocolJump", { url: url, title: title }, (res) => { });
  } else {
    location.href = url;
  }
}
// 跳转获取获取个人信息管理页面
function tcJumpGetCodeActivity(url, env = 0) {
  if (deviceCache.isApp) {
    if (env == 0) {
      url = location.origin + url;
    }
    JsBridge.callHandler("tcJumpGetCodeActivity", url, (res) => {
      //    callback(res)
    });
  } else {
    // callback(true)
    if (env == 0) {
      router.push(url);
    } else {
      location.href = url;
    }
  }
}
// 根据url跳转不同activity 并且finish当前activity
function tcJumpActivityFinishCurrent(url, env = 0) {
  if (deviceCache.isApp) {
    if (env == 0) {
      url = location.origin + url;
    }
    JsBridge.callHandler("tcJumpActivityFinishCurrent", url, (res) => {
      //    callback(res)
    });
  } else {
    // callback(true)
    router.push(url);
  }
}
// 更新APP
function tcUpdateApp(date) {
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcUpdateApp", date, (res) => { });
  }
}
// 授信成功的回调
function tcCreditSuccess() {
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcCreditSuccess", "", (res) => { });
  }
}
// 进件成功的回调
function tcIncomingParts() {
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcIncomingParts", "", (res) => { });
  }
}
// 保存数据
function tcSaveData(key, value) {
  if (deviceCache.isApp) {
    // saveToNativeKey和saveToNativeData 固定字段
    JsBridge.callHandler(
      "tcSaveData",
      { saveToNativeKey: key, saveToNativeData: value },
      (res) => { }
    );
  } else {
    localStorage.setItem(key, value);
  }
}
//获取app版本信息
function tcGetAppInfo() {
  return new Promise((resolve, reject) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcGetAppInfo", "", (res) => {
        resolve(res);
      });
    } else {
      resolve("不在app内");
    }
  });
}
//获取下载渠道信息
function tcGetChanelNumber() {
  return new Promise((resolve, reject) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcGetChanelNumber", "", (res) => {
        resolve(res);
      });
    } else {
      resolve("");
    }
  });
}
// 打电话
function tcCallPhone(phoneNumber) {
  if (deviceCache.isApp || deviceCache.isAideApp) {
    JsBridge.callHandler("tcCallPhone", phoneNumber, (res) => { });
  } else {
    window.location.href = `tel:${phoneNumber}`;
  }
}
// 是否显示首页遮罩
function tcIsShowOverlay(isShow) {
  if (deviceCache.isApp || deviceCache.isAideApp) {
    JsBridge.callHandler("tcIsShowOverlay", isShow, (res) => { });
  }
}
// 跳转权限管理页面
function tcJumpPermissionList() {
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcJumpPermissionList", "", (res) => { });
  }
}
// 清除缓存
function tcClearCache() {
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcClearCache", "", (res) => { });
  } else {
    caches.keys().then(function (names) {
      for (let name of names) {
        caches.delete(name);
      }
    });
  }
}
// 跳转到首页
function tcJumpFirstPage() {
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcJumpFirstPage", "", (res) => { });
  } else {
    router.push("/");
  }
}
// 获取通讯录中的手机号码
function tcGetPhoneContacts() {
  return new Promise((resolve, rej) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcGetPhoneContacts", "", (phone) => {
        resolve(phone);
      });
    } else {
      reject(new Error("不是APP内的调用"));
    }
  });
}
// 复制个人信息
function tcCopyMyInfo(info) {
  return new Promise((resolve, rej) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcCopyMyInfo", info, (callback) => {
        resolve(callback);
      });
    } else {
      // h5 复制
      var input = document.createElement("input");
      input.value = info;
      document.body.appendChild(input);
      input.select();
      (input.setSelectionRange(0, input.value.length), document.execCommand("Copy"));
      document.body.removeChild(input);
      resolve(true);
    }
  });
}
// 删除数据
function tcDeleteData(key) {
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcDeleteData", key, (res) => { });
  } else {
    localStorage.removeItem(key);
  }
}
// 获取数据 写法二
function tcGetSaveData(key) {
  return new Promise((resolve, reject) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcGetSaveData", key, (res) => {
        resolve(res);
      });
    } else {
      resolve(localStorage.getItem(key) || "");
    }
  });
}
// 获取数据 写法一
// function tcGetSaveData(key) {
//     return new Promise((resolve, reject) => {
//         if (isApp()) {
//             JsBridge.callHandler('tcGetSaveData', key, (res) => {
//                 resolve(res);
//             });
//         } else {
//             resolve(localStorage.getItem(key));
//         }
//     });
// }
// 获取APP登录信息
function tcGetLoginInfo() {
  return new Promise((resolve, rej) => {
    if (deviceCache.isApp || deviceCache.isAideApp) {
      JsBridge.callHandler("tcGetLoginInfo", "", (token) => {
        resolve(token);
      });
    } else {
      const token = localStorage.getItem("token") || null;
      resolve(token);
    }
  });
}
// 获取渠道信息
function tcGetAppChannelInfo() {
  return new Promise((resolve, rej) => {
    JsBridge.callHandler("tcGetAppChannelInfo", "", (token) => {
      resolve(token);
    });
  });
}
// 获取来源信息
function tcGetAppSourceType() {
  return new Promise((resolve, rej) => {
    JsBridge.callHandler("tcGetAppSourceType", "", (token) => {
      resolve(token);
    });
  });
}
import { useBubbleGuide } from "@/composables/useBubbleGuide";
const { safeClearStorage } = useBubbleGuide();

// 通知APP登录token过期
function tcTokenLoseEfficacy() {
  if (deviceCache.isApp || deviceCache.isAideApp) {
    localStorage.clear();
    JsBridge.callHandler("tcTokenLoseEfficacy", "", (res) => { });
  } else {
    safeClearStorage();
    router.push("/");
  }
}
// 调用Native Toast
function tcShowToast(content) {
  JsBridge.callHandler("tcShowToast", content, (res) => { });
}
// 展示账单list tab
function tcShowListTab() {
  JsBridge.callHandler("tcShowListTab", "", (res) => { });
}
// 跳转账单list tab
function tcSwiftListTab() {
  JsBridge.callHandler("tcSwiftListTab", "", (res) => { });
}
// 跳转登录
function tcJumpAppLogin() {
  if (deviceCache.isApp || deviceCache.isAideApp) {
    JsBridge.callHandler("tcJumpAppLogin", "", (res) => { });
  } else {
    router.push("/login");
  }
}
// 挽留弹窗弹出的回调
function tcFinishListener(callback) {
  if (deviceCache.isApp) {
    JsBridge.registerHandler("tcFinishListener", (res) => {
      callback(res);
    });
  }
}
// 调用相机并上传
function syTcStartCamera(isFront) {
  return new Promise((resolve, reject) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcStartCamera", isFront, (res) => {
        if (res && res.error) {
          reject(new Error(res.error));
        } else {
          resolve(res);
        }
      });
    } else {
      reject(new Error("不是APP内的调用"));
    }
  });
}
// 调用相册并上传
function syTcStartAlbum(isFront) {
  return new Promise((resolve, reject) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcStartAlbum", isFront, (res) => {
        if (res && res.error) {
          reject(new Error(res.error));
        } else {
          resolve(res);
        }
      });
    } else {
      resolve(false);
      // reject(new Error('不是APP内的调用'));
    }
  });
}
// 返回销毁当前Activity
function tcFinishCurrentActivity(callback) {
  if (deviceCache.isApp) {
    return JsBridge.callHandler("tcFinishCurrentActivity", "", (res) => callback);
  } else {
    return router.go(-1);
  }
}
// 苹果甜瓜好用app专用   返回销毁当前Activity
function tcFinishCurrentAideAppActivity(callback) {
  if (deviceCache.isAideApp) {
    return JsBridge.callHandler("tcFinishCurrentAideAppActivity", "", (res) => callback);
  }
}
// 返回销毁当前Activity 返回两层 单独为活体识别处理  app内正常返回  h5 内返回两层
function tcFinishCurrentActivityV2(callback) {
  if (deviceCache.isApp) {
    return JsBridge.callHandler("tcFinishCurrentActivity", "", (res) => callback);
  } else {
    return router.push("/creditList");
  }
}
// 返回销毁当前Activity 最高优先级方法
function tcFinishActivityHighestPriority(isFromInfoOrOcr = false) {
  if (deviceCache.isApp) {
    return JsBridge.callHandler("tcFinishActivityHighestPriority", isFromInfoOrOcr, (res) => { });
  } else {
    return router.go(-1);
  }
}
// 销毁弹窗返回标识
function tcFinishFlag() {
  if (deviceCache.isApp) {
    return JsBridge.callHandler("tcFinishFlag", "", (res) => { });
  }
}
// 是否展示loading  true 展示 false隐藏
function tcIsShowLoadDialog(flag, timer) {
  timer = timer || 1000;
  if (deviceCache.isApp) {
    JsBridge.callHandler("tcIsShowLoadDialog", flag, (res) => callback);
  } else {
    if (flag) {
      //TODO:h5 加载动画
      showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: timer,
      });
    } else {
      closeToast();
    }
  }
}

// 获取位置信息
function tcGetAppLocation() {
  return new Promise((resolve, rej) => {
    if (deviceCache.isApp) {
      JsBridge.callHandler("tcGetAppLocation", "", (res) => {
        resolve(res || "");
      });
    } else {
      resolve("");
    }
  });
}

// 设置主题id tg_blue/tg_green 类似黑暗模式切换（前端 -> Native）
function tcSetThemeId(themeId) {
  return new Promise((resolve, reject) => {
    JsBridge.callHandler("tcSetThemeId", themeId, (res) => {
      resolve(res);
    });
  });
}

// 监听 Native 主题变化（Native -> 前端）
function tcOnThemeChange(callback) {
  JsBridge.registerHandler("tcOnThemeChange", (themeId) => {
    callback(themeId);
  });
}

export {
  tcAppOnCrate,
  tcAppOnResume,
  isApp, // 是否在app内
  isAndroid,
  isIos,
  h5Debug, // 调试模式检测
  tcGetAppInfo,
  syTcStartCamera,
  syTcStartAlbum,
  tcJumpActivity,
  tcJumpAideAppActivity,
  isAideApp,
  tcOpenCalculatorPage,
  tcGetLoginInfo,
  tcGetAppChannelInfo,
  tcGetAppSourceType,
  tcTokenLoseEfficacy,
  tcJumpAppLogin,
  tcSaveData,
  tcDeleteData,
  tcGetSaveData,
  tcJumpActivityFinishCurrent,
  tcFinishCurrentActivity,
  tcFinishCurrentAideAppActivity,
  tcFinishCurrentActivityV2,
  tcIsShowLoadDialog, //loading
  tcShowToast,
  tcCallPhone,
  tcClearCache,
  tcGetPhoneContacts,
  tcJumpPermissionList,
  tcCopyMyInfo,
  tcThreeUploadError,
  tcJumpGetCodeActivity,
  tcJumpFirstPage,
  tcFinishListener,
  tcFinishActivityHighestPriority,
  tcOtherProtocolJump,
  tcFinishFlag,
  tcUpdateApp,
  tcTabChange,
  tcShowListTab,
  tcSwiftListTab,
  tcKeyboardStatus,
  tcAppOnPause,
  tcIsShowOverlay,
  tcGetChanelNumber,
  tcAppOnDestroy,
  tcCreditSuccess,
  tcIncomingParts,
  tcGetAppLocation,
  tcSetThemeId,
  tcOnThemeChange,
};
